// extracted by mini-css-extract-plugin
export default {"container":"NewBadge_container__xBN6n"};